// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export function createAddOfferToComparisonModel(parameters) {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'offers-comparison',
    pathApi: '/v2/add-offer-to-comparison/',
    response: {
      200: {
        contentType: 'json'
      },
      400: {
        contentType: 'json'
      }
    },
    request: {
      contentType: 'json',
      parameters
    }
  };
}
export async function fetchAddOfferToComparison(_ref) {
  let {
    httpApi,
    config,
    mappers,
    parameters
  } = _ref;
  const {
    statusCode,
    response,
    headers
  } = await httpApi.fetch(createAddOfferToComparisonModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response, headers);
    }
  }
  return {
    statusCode,
    response,
    headers
  };
}